const classSignIn = {
  path: 'classSingIn/:classId',
  props: true,
  component: resolve => require(['../../../../components/pages/student_user/classSingIn'], resolve)
}
export default classSignIn



// WEBPACK FOOTER //
// ./src/router/pages/student_user/classSingIn/index.js